import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './home/HeroSection';
import { TrustStrip } from './home/TrustStrip';
import { ServicesSection } from './home/ServicesSection';
import { MissionSection } from './home/MissionSection';
import { EventsSection } from './home/EventsSection';
import { ContactSection } from './home/ContactSection';
export function HomePage() {
  return <div className="min-h-screen flex flex-col" data-id="element-761">
      <Navbar data-id="element-762" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-763">
        <HeroSection data-id="element-764" />
        <TrustStrip data-id="element-765" />
        <ServicesSection data-id="element-766" />
        <MissionSection data-id="element-767" />
        <EventsSection data-id="element-768" />
        <ContactSection data-id="element-769" />
      </main>
      <Footer data-id="element-770" />
    </div>;
}